export default __webpack_public_path__ + "media/images/react_icons/success-large-ae1a94f631c86e5bffc21702cb76e670.svg";